export default {
  Anemo: ['#34c5a0', '#36f9da'],
  Cryo: ['#61ceff', '#81ffff'],
  Dendro: ['#66d23e', '#00ea55'],
  Electro: ['#915be9', '#cb8aff'],
  Geo: ['#ffbb3c', '#fff545'],
  Hydro: ['#1893ff', '#19d0ff'],
  Pyro: ['#e35846', '#ff8c7d']
};
